export default __webpack_public_path__ + "static/peachdish-9d850a85d7aa1c3be1e9b93f5004e5ee.png";